<div class="propero-home">
  <!-- Hero -->
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'HELP_CENTER.HERO_EYEBROW' | translate }}
      </div>

      <h1 class="ph-hero__title">{{ 'HELP_CENTER.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'HELP_CENTER.TITLE_DESCRIPTION' | translate }}</p>

      <div class="ph-hero__actions ph-hero__actions--centered">
        <a href="#faq" class="ph-btn ph-btn--brand ph-btn--lg">{{ 'HOME.SECTION_FAQ_TITLE' | translate }}</a>
        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline ph-btn--lg">
          {{ 'HOME.ACCESS_DASHBOARD' | translate }}
        </a>
      </div>
    </div>
  </section>

  <!-- FAQ -->
  <section id="faq" class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'HOME.SECTION_FAQ_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HOME.SECTION_FAQ_TEXT' | translate }}</p>
      </div>

      <div class="ph-faq">
        <div *ngFor="let item of faqItems; let i = index" class="ph-faq__item">
          <button
            type="button"
            class="ph-faq__trigger"
            (click)="toggleFaq(i)"
            [attr.aria-expanded]="openFaqIndex === i">
            <span>{{ item.questionKey | translate }}</span>
            <i class="lni lni-chevron-down ph-faq__chevron" [class.ph-faq__chevron--open]="openFaqIndex === i"></i>
          </button>
          <div class="ph-faq__panel" *ngIf="openFaqIndex === i">
            <p>{{ item.answerKey | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Resources -->
  <section id="resources" class="ph-section">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'HELP_CENTER.RESOURCES_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HELP_CENTER.RESOURCES_LEAD' | translate }}</p>
      </div>

      <div class="ph-tools__grid">
        <a *ngFor="let link of resourceLinks" [routerLink]="link.route" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni" [ngClass]="link.icon"></i></div>
          <h3 class="ph-tool-card__title">{{ link.titleKey | translate }}</h3>
          <p class="ph-tool-card__text">{{ link.textKey | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'HOME.LEARN_MORE' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>

  <!-- Support CTA -->
  <section id="support" class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-help-cta">
        <div class="ph-help-cta__badge">{{ 'HELP_CENTER.SOON' | translate }}</div>
        <p class="ph-help-cta__text">{{ 'HELP_CENTER.SOON_NOTE' | translate }}</p>
        <div class="ph-help-cta__actions">
          <a routerLink="/contact" class="ph-btn ph-btn--brand ph-btn--lg">
            {{ 'HELP_CENTER.CONTACT_CTA' | translate }}
          </a>
          <a href="mailto:contact@propero.io" class="ph-btn ph-btn--outline ph-btn--lg">contact@propero.io</a>
        </div>
      </div>
    </div>
  </section>
</div>
